export default class utils {
    /**
     * 时间格式化
     * @param {[date，type]}
     */
    static formatTime(date, type) {
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        const hour = date.getHours()
        const min = date.getMinutes()
        const second = date.getSeconds()
        const resetType = type === 1 ? '/' : '-'
        return [year, month, day].map(this.formatNumber).join(resetType) + ' ' + [hour, min, second].map(this.formatNumber).join(':')
    }
    /**
     *  不足10 补0
     * @param {*} n
     */
    static formatNumber(n) {
        n = n.toString()
        return n[1] ? n : '0' + n
    }
    /**
     * 
     * @param {*} date '2019-01-01 00:00:00'
     * 
     * @return {*} date '2019/01/01 00:00:00'  
     */
    static fliterDate(date) {
        let newDate = date.substring(0, 19)
        return newDate.replace(/-/g, '/')
    }

    /**
     * [checkPhone 手机号验证]
     *
     * @param   {[type]}  phone  [phone 手机号]
     *
     * @return  {[type]}         [return true 验证通过 反之]
     */
    static checkPhone(phone) {
        if (!(/^1[3456789]\d{9}$/.test(phone))) {
            return false;
        } else {
            return true;
        }
    }
    /**
     * [checkIdCard 校验身份证是否合法  简单校验]
     *
     * @param   {[type]}  id  [id 身份证号]
     *
     * @return  {[type]}      [return true验证通过]
     */
    static checkIdCard(id) {
        let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (!regIdNo.test(id)) {
            return false
        } else {
            return true
        }
    }
    /**
     * [isDigit 校验内容是否全部由数字组成]
     *
     * @param   {[type]}  s  [s 校验内容]
     *
     * @return  {[type]}     [return 布尔值]
     */
    static isDigit(s) {
        var patrn = /^[0-9]{1,20}$/
        if (!patrn.exec(s)) return false
        return true
    }
    /**
     * [checkName 校验用户名：只能输入4-16个汉字、数字、字母、下划线字串  ]
     *
     * @param   {[type]}  name  [name 校验内容]
     *
     * @return  {[type]}        [return description]
     */
    static checkName(name) {
        var reg = /^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]+$/
        ///<summary>获得字符串实际长度，中文2，英文1</summary>
        ///<param name="name">要获得长度的字符串</param>
        var realLength = 0, len = name.length, charCode = -1;
        for (var i = 0; i < len; i++) {
            charCode = name.charCodeAt(i);
            if (charCode >= 0 && charCode <= 128) realLength += 1;
            else realLength += 2;
        }
        if (realLength < 4) {
            //小于4位
            return 2
        } else if (this.isDigit(name)) {
            // 不能纯数字
            return 1
        } else if (reg.test(name)) {
            //符合规则  
            return 4;
        } else {
            //不符合规则  特殊字符
            return 3;
        }
    }
    /**
     * 不小于6位 不能含有中文
     */
    static checkPassWord(password) {
        var reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
        if (reg.test(password)) {
            return 1; // 不能含有中文
        }
        if (password == null || password == undefined || password.length < 6) {
            return 2; // 6-16位
        }
        return 3
    }
    /**
     * 是不是 safair
     */
    static isSafari() {
        var ua = navigator.userAgent.toLowerCase();
        //判断是不是移动端iPHone Safair浏览器打开的本页面
        if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1
            && ua.indexOf('linux') == -1 && ua.indexOf('android') == -1) {
            return true
        }
        else {
            return false
        }
    }
    /**
     * 是不是微信内置浏览器
     */
    static isWxBrowser() {
        var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i) == "micromessenger" || ua.match(/QQ\/[0-9]/i) || ua.match(/WeiBo/i) == "weibo") {
            //在微信或QQ、微博打开
            return true
        }
    }
    /**
     * [browserType  获取浏览器类型 只判断Chrome Safari和微信内置浏览器]
     *
     * @return  {[type]}  [return description]
     */
    static browserType() {
        var userAgent = navigator.userAgent;
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return 'wx';
        }
        if (userAgent.indexOf("Safari") > -1 && window.external) {
            return "Chrome"
        }
        if (userAgent.indexOf("Safari") > -1 && !window.external) {
            return "Safari"
        }
        return 'shit'
    }
    /**
     * [getPwdLvl 密码等级校验 密码: 数字,字母,特殊符号]
     *
     * 密码: 只有数字- 或者是只有字母,或者是只有特殊符号---1级---弱
     *       两两组合: 数字和字母, 数字和特殊符号, 字母和特殊符号-----2级----中
     *       三者都有: 数字和字母和特殊符号------3级-----强
     * @param   {[type]}  pwd  [pwd 密码]
     *
     * @return  {[type]}       [return 级别]
     */
    static getPwdLevel(pwd) {
        var lvl = 0;//默认是0级
        //密码中是否有数字,或者是字母,或者是特殊符号
        if (/[0-9]/.test(pwd)) {
            lvl++;
        }
        //判断密码中有没有字母
        if (/[a-zA-Z]/.test(pwd)) {
            lvl++;
        }
        //判断密码中有没有特殊符号
        if (/[^0-9a-zA-Z_]/.test(pwd)) {
            lvl++;
        }
        //最小的值是1,最大值是3
        return lvl;
    }
    static geTel(tel) {
        if (!this.isDigit(tel)) {
            return tel
        }
        var reg = /^(\d{3})\d{4}(\d{4})$/;
        return tel.replace(reg, "$1****$2");
    }
    /**
     * 获取指定的URL参数值
     * 参数：paramName 参数名
     * 调用方法:this.utils.getUrlParam("name")
     * 返回值:tyler
     * 0：H5
     * 1:抢多多客户端
     * 2：推广客户端
     */
    static getUrlParam(paramName) {
        var query = localStorage.getItem("hrefStr").split('?')[1];
        if(query){
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("?");
                var isClient = pair[0].split('=')[1]
                if(isClient == paramName){return true;}
            }
        }
        return(false);
    }
    /**
     * 对象转url参数
     * @param {*} data
     * @param {*} isPrefix
     */
    static urlencode(data, isPrefix = false) {
        let prefix = isPrefix ? '?' : ''
        let _result = []
        for (let key in data) {
            let value = data[key]
            // 去掉为空的参数
            if (['', undefined, null].includes(value)) {
                continue
            }
            if (value.constructor === Array) {
                value.forEach(_value => {
                    _result.push(encodeURIComponent(key) + '[]=' + encodeURIComponent(_value))
                })
            } else {
                _result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
            }
        }
        return _result.length ? prefix + _result.join('&') : ''

    }
    /**
     * [clientLink 客户端通讯]
     *
     * @param   {[type]}  params  [params 参数对象]
     *
     * @return  {[type]}          [return 无返回值]
     */
    static clientLink(params) {
        if(localStorage.getItem("channelSrc")&&localStorage.getItem("channelSrc").indexOf('202') != -1){
            window.location.href = `http://clientlink.caiminbang.com?${this.urlencode(params)}`
        }
    }
    /**
     * [isClient 是否是客户端]
     *
     * @return  {[type]}          [return false不是  true是]
     * 0：H5
     * 1:抢多多客户端
     * 2：推广客户端
     */
    static isClient() {
        let channelSrc = localStorage.getItem("channelSrc")
        if(channelSrc){
            let clients = channelSrc.substring(16,19)
            if(clients==='202'){
                return 1
            }else{
                return 2
            }
        }else{
            return 0
        }
    }
    /**
     * 判断快3 AppStore
     */

    static isK3() {
        let channelSrc = localStorage.getItem("channelSrc")
        if(channelSrc){
            let clients = channelSrc.substring(0,10)
            if(clients==='1999900001'){
                return true
            }else{
                return false
            }
          
        }else{
            return false
        }
    }


    /**
     * 处理url参数
     */
    static hrefObj(localhref) {
            if(localhref.indexOf("?")==-1) return false
            let localarr = localhref.split('?')[1].split('&');
            var tempObj = {};
            for (let i = 0; i < localarr.length; i++) {
            　　tempObj[localarr[i].split('=')[0]] = localarr[i].split('=')[1];
            }
            return tempObj;
        }
    /**
     * [systemType 判断手机系统类型]
     *
     * @return  {[type]}  [return description]
     */
    static systemType() {
        var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
            return 'Android'
        }
        if (isIOS) {
            return 'ios'
        }
    }
    //设置cookie,增加到vue实例方便全局调用
    static setCookie(c_name, value, expiredays) {
        var exdate = new Date()
        exdate.setDate(exdate.getDate() + expiredays)
        let path ='/'
        // document.cookie = c_name + “=” + encodeURIComponent(value)+’;expires’ +exdate.toGMTString()+’;path=’+path+’;domain=’+domain; 设置成功后不在登陆 
        document.cookie = c_name + '=' + value +'; expires' + exdate.toGMTString() +'; path ='+path
    }
    //获取cookie、
    static getCookie(cname) {
        var name = cname + '=';
        var ca = document.cookie.split('; ')
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) == '') c = c.substring(1)
            if (c.indexOf(name) != -1) return c.substring(name.length, c.length)
        }
        return ''
    }
    //删除cookie
    static delCookie(name) {
        var exp = new Date()
        exp.setTime(exp.getTime() - 1)
        var cval = getCookie(name)
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()
    }
    static request_url(){
        var strs;
        var url = localStorage.getItem("hrefStr");
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.split("?");
            strs = str[1].split("&");
            for (var i = 0; i < strs.length; i++) {
                if(i < strs.length-1){
                    theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
                }else{
                    var s = strs[i].split("=")[1];
                    var ss = s.split("&");
                    theRequest[strs[i].split("=")[0]] =ss[0];
                }
            }
        }
        return theRequest;
    }
}


// WEBPACK FOOTER //
// ./src/utils/utils.js